module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAAPCAYAAAACsSQRAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH3wgGDCAvDejw2AAAAIFJREFUOMvt0jEKwkAQheEvYmEXT5DC43iE1CFHFDxBSo8S62CyNruwhYGwsbDwwcA8ZuZnBgY6TAgFMaGrYvLEDZXtCrjinMygTAPCwRf0h/wy5JjBTpnfole+xFj48ilGaHdC2rRNjQt63DGvDMyx3sf++tOdDR5YViBLrDf50BtJUksvzAFJnwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/tv_black.png
// module id = 916
// module chunks = 7